const BASE = import.meta.env.BASE_URL;

export function RuvilyMark({ size = 32, className = '' }) {
  return (
    <img
      src={`${BASE}ruvily-mark.svg`}
      alt="Ruvily"
      width={size}
      height={size}
      className={className}
    />
  );
}

export function RuvilyLogo({ height = 28, className = '', variant = 'default' }) {
  const src = variant === 'light' ? `${BASE}ruvily-logo-light.svg` : `${BASE}ruvily-logo.svg`;
  return (
    <img
      src={src}
      alt="Ruvily"
      height={height}
      style={{ height }}
      className={className}
    />
  );
}
